import Chip from "@mui/material/Chip";
import {
	BudgetConsumption,
	BudgetLimitEnforcementMode,
} from "@/domain/program.interface";

interface BudgetBadgeProps {
	consumption: BudgetConsumption;
	threshold?: number;
	mode?: BudgetLimitEnforcementMode;
}

/**
 * SIMS-6099 — budget consumption badge for a program card on the Program list.
 * Shows the percentage consumed; color-coded distinct when at/over threshold.
 * Rendered only for budget-enabled programs (the parent omits it otherwise).
 */
export default function BudgetBadge({
	consumption,
	threshold,
	mode,
}: BudgetBadgeProps): JSX.Element {
	const pct = consumption.percentage;
	const over = threshold != null && pct >= threshold;
	const near = threshold != null && !over && pct >= threshold - 10;
	const color: "success" | "warning" | "error" =
		over && mode === "BLOCK" ? "error" : over || near ? "warning" : "success";
	const label =
		over && mode === "BLOCK"
			? `${pct}% · Blocked`
			: over && mode === "WARN"
				? `${pct}% · Warning`
				: near
					? `${pct}% · Near limit`
					: `${pct}% of budget used`;

	return (
		<Chip
			size="small"
			color={color}
			label={label}
			data-testid="program-budget-badge"
		/>
	);
}
